const styles = theme => ({
  stepperopnerList: {
    padding: '0',
    '& $label': {
      fontSize: '10px',
    },
    '& $labellistActive': {
      color: '#1C999B',
      fontWeight: '600',
    },
    '& button': {
      padding: '7px',
      color: '#342D3D',
      margin: '0',
      justifyContent: 'center',
      '& $activeIcon': {
        color: '#1FCACC',
        '& $completed': {
          fill: '#fff',
        },
      },
      '&:hover': {
        background: '#EFFBFC',
        '& $completed': {
          fill: '#1C999B',
        },
        '& $label': {
          color: '#1C999B',
          fontWeight: '600',
        },
      },
    },
  },
  activeIcon: {},
  label: {},
  labellistActive: {},
  listingiconRoot: {
    color: '#F8F8F8',
  },
  completed: {
    fill: '#565960',
    fontSize: '14px',
    fontWeight: '400',
  },
  stepButtonComplete: {
    '& > span > span:first-child > svg': {
      color: theme.palette.primary.adgmGreen,
    },
    '& > span > span:last-child > span': {
      color: theme.palette.primary.adgmGreen,
    },
  },
  panels: {
    display: 'grid',
    gridTemplateColumns: 'auto',
  },
  navigatorContainer: {
    display: 'flex',
    '& button': {
      minWidth: '151px',
      padding: '15px',
      height: '60px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '10px',
      color: '#fff',
      textTransform: 'capitalize',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
    },
    '& $nextButton': {
      background: theme.palette.primary.main,
      marginLeft: 'auto',
      '&:disabled': {
        backgroundColor: theme.palette.primary.darkGrey,
        cursor: 'not-allowed !important',
      },
    },
    '& $backButton': {
      color: '#342D3D',
      border: '1px solid #342D3D',
      '&:disabled': {
        backgroundColor: theme.palette.primary.grey,
        cursor: 'not-allowed !important',
      },
    },
  },
  nextButton: {},
  backButton: {},

  gridItemFullWidth: {
    gridColumn: '1 / span 2',
  },
  preFilledField: {
    '& .MuiOutlinedInput-root': {
      background: theme.palette.primary.borderColor,
      color: theme.palette.primary.dim,
    },
  },
  borderTop: {
    borderTop: '1px solid #EBEEF3',
    marginTop: '10px',
    paddingTop: '10px',
  },

  '@media (min-width:768px)': {
    stepperopnerList: {
      padding: '0',
      '& span': {
        border: '0',
      },
      '& $label': {
        color: '#342D3D',
        marginBottom: '4px',
        fontSize: '14px',
      },
      '& $labellistActive': {
        color: '#1C999B',
        fontWeight: '600',
      },
      '& button': {
        padding: '12px 20px 12px 0',
        borderRadius: '10px',
        boxSizing: 'border-box',
        color: '#342D3D',
        margin: '0',
        justifyContent: 'flex-start',
        textAlign: 'left',
        '& $activeIcon': {
          color: 'transparent',
          '& $completed': {
            fill: '#1C999B',
          },
        },
        '&:hover': {
          background: '#EFFBFC',
          '& $completed': {
            fill: '#1C999B',
          },
          '& $label': {
            color: '#1C999B',
            fontWeight: '600',
          },
        },
      },
    },
    listingiconRoot: {
      color: 'transparent',
    },
    completed: {
      fill: '#342D3D',
      fontSize: '20px',
      fontWeight: '500',
    },
  },
  '@media (max-width:767px)': {
    stepperopnerList: {
      flexDirection: 'row',
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      '& button': {
        '&:after': {
          content: '""',
          background: '#bdbdbd',
          height: '1px',
          top: '18px',
          left: 'calc(50% + 12px)',
          right: 'calc(-50% + 12px)',
          position: 'absolute',
        },
      },
      '& > div': {
        '&:last-child button': {
          '&:after': {
            background: 'transparent',
          },
        },
      },
      '& $label': {
        whiteSpace: 'normal',
      },
    },
    MuiStepLabelRoot: {
      flexDirection: 'column',
    },
    MuiStepLabeliconContainer: {
      paddingRight: '0',
      marginBottom: '4px',
    },
    '@media (max-width:767px)': {
      navigatorContainer: {
        position: 'fixed',
        bottom: '0',
        left: '0',
        right: '0',
        background: '#fff',
        padding: '16px',
        borderTop: '3px solid #EBEEF3',
        zIndex: '1021',
        margin: '0 -5px',
        '& button': {
          width: '100%',
          margin: '0 5px',
          height: '48px',
        },
        '& $nextButton': {
          margin: '0 5px',
        },
      },
    },
  },
});

export default styles;
